import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, AfterViewChecked, ChangeDetectorRef, Renderer2, ElementRef } from '@angular/core';
import { GridColumn, ColumnFieldType, CustomValidationResult } from '../../Models/GridColumn';
import { PaginationConfiguration } from '../../Models/PaginationConfiguration';

import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { map } from "rxjs/operators";
import { LookupKeyValue } from '../../../../models/lookup-key-value';
import { Table } from '../../../../primeng/components/table/table';
import { UploaderComponent } from '../../../../Uploader/Components/uploader/uploader.component';
import { PopupService } from '../../../../modules/popup/popup.service';
import { DocumentConfiguration } from '../../../../Uploader/Models/DocumentConfiguration';
import { DocumentModel } from '../../../../Uploader/Models/DocumentModel';
import { debug } from 'util';
import { CustomValidationResultResponse } from '../../../../models/custom-validation-result';
import { NoWhitespaceDirective } from '../../../../directives/no-whitespace.directive';
import { NoWhitespaceValidator } from '../../../../validator/no-whitespace.validator';

import { ResultDetails } from 'Shared/models/result-details';

import { HttpClient, HttpHeaders } from '@angular/common/http';
//import {  HttpClient, HttpHeaders  } from '@angular/http';


@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html'
})
export class GridComponent implements OnInit, AfterViewInit, AfterViewChecked {
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  //=============================================================================================
  // Data for Grid >>> 2 way binding acquires @Input and @output
  @Input()
  set data(data: any[]) {
    this.tempData = new Array<any>();
    if (data) {
      for (let item of data) {
        if (!item[this.isDeleted]) {
          this.tempData.push(item);
        }
      }
      this.tempDataToEmit = Array.from(data);
    }
    else {
      this.tempDataToEmit = new Array<any>();
    }
  }

  @Output() dataChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Input() allAttachments: any[];
  @Output() allAttachmentsChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  tempData: any[];
  tempDataToEmit: any[];

  loadedValueInDrop: any[] = new Array<any>();
  //=============================================================================================
  @Input() showItemFormByDefault: boolean;
  @Input() totalRecords: number;
  @Input() columns: GridColumn[];
  @Input() header: string;
  @Input() paginationConfig: PaginationConfiguration;
  @Input() editable: boolean;
  @Input() disableDelete: boolean = false;
  @Input() disableAdd: boolean = false;

  @Input() isSearchEnabled: boolean;

  @Input() resources: any;

  @Input() lookupsEntities: { [id: number]: LookupKeyValue[] };
  @Input() documentsConfigurations: { [id: number]: DocumentConfiguration[] };
  @Input() lookupKey: any = "Key";
  @Input() lookupLabel: any = "Name";

  @Input() isDeleted: any = "IsDeleted";
  @Input() isUpdated: any = "IsUpdated";
  @Input() editButtonLabel: string = null;

  @Input() minRequiredRows: number; // to be implemented
  @Input() maxRequiredRows: number; // to be implemented

  @Input() preSaveFn: (item: any) => Observable<CustomValidationResultResponse>; // Not working properly
  @Output() postSaveItemHandler: EventEmitter<any> = new EventEmitter();

  @Input() preDeleteFn: (item: any) => Observable<boolean>; // Not working properly
  @Output() postDeleteItemHandler: EventEmitter<any> = new EventEmitter();

  @Output() DropdownChange?: EventEmitter<any> = new EventEmitter();


  //@Input() errors: CustomValidationResult[];

  @Output() onRowSelect: EventEmitter<any> = new EventEmitter();
  @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();

  @Input() datePickerOptions: any = {};
  @Input() dateTimePickerOptions: any = { timepicker: true };
  @ViewChild(Table) dt: Table;


  gridAttachments: Array<DocumentModel>;

  selectedItem: any;

  itemForm: FormGroup;
  itemFormSubmitted: boolean;

  editItemForms: FormGroup[];
  editItemFormsSubmitted: boolean;
  disableForEstablishment: boolean = true;
  selectedRowDetails: number;
  showRowDetails: boolean;
  showItemForm: boolean;
  //constructor(private http: Http);
  visibleColumns: GridColumn[];
  editableColumns: GridColumn[];
  nonEditOrViewColumns: GridColumn[];
  undefinedOption: any;
  defaultDateFormat: string;
  defaultDateTimeFormat: string;
  requiredValidator = Validators.required;
  preSaveValidation: CustomValidationResultResponse;

  EditedIndex: any;

  private isValidateUploader: boolean = false;
  indexedUploaderArray: { [key: string]: boolean } = {};

  deletionPopupId: string;
  documentConfig: DocumentConfiguration;
  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private modalService: PopupService,
    private cdRef: ChangeDetectorRef,
    private datepipe: DatePipe) {
    this.editItemForms = new Array<FormGroup>();
    this.tempData = new Array<any>();
    this.loadedValueInDrop = new Array<any>();
    this.undefinedOption = null;
    this.defaultDateFormat = "yyyy-MM-dd";
    this.defaultDateTimeFormat = "yyyy-MM-dd HH:ii";
    this.deletionPopupId = this.makeRandom()
    this.documentConfig = {
      Name: "test",
      Key: 1,
      AllowedExtension: ".pdf,.jpg,.png,.txt,docx",
      AllowedSize: 5242880,
    };
    //this.preSaveValidation = new CustomValidationResultResponse();
  }

  //=============================================================================================
  // Grid Component Lifecycle Hooks
  ngOnInit(): void {
    // Initialize necessary input for grid if null or undefined
    if (this.columns) {


      if (this.columns.filter(a => a.header == 'Edit' && a.typeConfig.type == ColumnFieldType.None).length <= 0) {
        this.columns.push({
          field: '',
          header: 'Edit',
          typeConfig: {
            type: ColumnFieldType.None
          }
        },
          {
            field: '',
            header: 'View',
            typeConfig: {
              type: ColumnFieldType.None
            }
          });
      }
    }
    this.visibleColumns = this.FilterVisibleColumns(this.columns);
    this.editableColumns = this.FilterEditableColumns(this.columns);
    this.nonEditOrViewColumns = this.FilterNonEditOrViewColumns(this.columns);
    if (!this.paginationConfig) {
      this.paginationConfig = {
        paginator: true,
        rows: 5
      };
    }
    // Add/Edit Form initialization
    this.CreateItemForm();
    this.CreateEditItemForms();
    if (this.editableColumns && this.editableColumns.length > 0 && this.editableColumns.filter(x => x.typeConfig.type == ColumnFieldType.Uploader).length > 0)
      this.isValidateUploader = true;

    if (this.showItemFormByDefault) {
      this.ShowItemForm();
    }
    //Begin  - Establishment services
    var url = window.location.href;
    if (url.toLowerCase().indexOf('establishment') > -1) {
      this.resources.g_lbl_girdAddNewRow = this.resources.lbl_AddNewSignatory;
      if (true) {
        this.paginationConfig = {
          paginator: true,
          rows: 10
        };
      }
    }
    if (url.toLowerCase().indexOf('update-establishment') > -1 ) {
      this.disableForEstablishment = false;
    }
    if (url.toLowerCase().indexOf('renew-establishment') > -1) {
      this.disableForEstablishment = false;
      this.disableDelete = true;
      this.disableAdd = true;
    }
    if (url.toLowerCase().indexOf('cancel-establishment') > -1) {
      this.disableForEstablishment = false;
      this.disableDelete = true;
      this.disableAdd = true;
    }

    //End  - Establishment services
  }

  ngAfterViewInit(): void {

  }

  //=============================================================================================
  // Grid Events to allow Grid user pass the needed logic for these scenarios...
  OnRowSelect() {
    this.onRowSelect.emit(this.selectedItem);
  }

  LoadLazy(event) {
    this.onLazyLoad.emit({
      pageNumber: event.first == 0 ? 0 : (event.first / this.paginationConfig.rows)
    });
    //this.dt.reset();
  }

  //=============================================================================================
  // ItemForm Operations

  isSubmittedUploader = false;
  isValidAttachments = false;
  setUploaderValidity(isValid: boolean, col: GridColumn): void {
    if (col.typeConfig.isAttachmentRequired) {
      this.indexedUploaderArray[col.label] = isValid;
    }
    this.isValidAttachments = true;
    let _uploaders = this.columns.filter(x => x.typeConfig.type == ColumnFieldType.Uploader && x.typeConfig.isAttachmentRequired == true && x.editable == true)
    if (_uploaders) {
      for (var i = 0; i < _uploaders.length; i++) {
        if (!this.indexedUploaderArray[_uploaders[i].label])
          this.isValidAttachments = false;
      }
    }

  }

  OnSubmitItemForm() {
    this.itemFormSubmitted = true;
    this.isSubmittedUploader = true;
    let self = this;
    setTimeout(function (this) {
      if (!self.isValidateUploader)
        self.isValidAttachments = true;
      if (self.itemForm.valid && self.isValidAttachments) {
        self.CreateItem();
      }
      else
        self.scrollUpToFirstError();
    });
  }


  private cloneAttachments(attachments: any[], pushTogridAttachments: boolean = false): DocumentModel[] {
    let clonedAttachments: DocumentModel[] = new Array<DocumentModel>();
    if (attachments != null) {
      for (var i = 0; i < attachments.length; i++) {
        let newDocument: DocumentModel = new DocumentModel(attachments[i]);
        clonedAttachments.push(newDocument);
        if (pushTogridAttachments)
          this.gridAttachments.push(newDocument);
      }
    }
    return clonedAttachments;
  }

  private cloneGridAttachmentsToAllAttachments(updateExistingDocumentsAttachments: boolean = true): void {
    if (this.allAttachments) {
      if (this.gridAttachments && this.gridAttachments.length > 0) {
        for (var i = 0; i < this.gridAttachments.length; i++) {
          if (updateExistingDocumentsAttachments) {
            let existingDocument = this.allAttachments.filter(x => x.TempId == this.gridAttachments[i].TempId && x.RealId == this.gridAttachments[i].RealId);
            if (existingDocument && existingDocument.length > 0) {
              let index = this.allAttachments.indexOf(existingDocument[0]);
              if (index > -1) {
                this.allAttachments[index] = this.gridAttachments[i];
              }
            }
            else
              this.allAttachments.push(this.gridAttachments[i]);
          }
          else
            this.allAttachments.push(this.gridAttachments[i]);
        }
      }
      this.allAttachmentsChange.emit(this.allAttachments);
    }
  }

  private CreateItem(): void {
    var newItem: any = {};
    this.indexedUploaderArray = {};
    for (let col of this.FilterEditableColumns(this.columns)) {
      if (col.typeConfig.type == ColumnFieldType.Uploader) {
        newItem[col.field] = this.cloneAttachments(this.itemForm.controls[col.field].value, true);

        this.indexedUploaderArray[col.label] = !col.typeConfig.isAttachmentRequired;
      }
      else
        newItem[col.field] = this.itemForm.controls[col.field].value;
    }
    newItem['Status'] = "Add";
    newItem['PrivatId'] = this.makeRandom();
    // pre save
    if (this.preSaveFn) {
      this.preSaveFn(newItem).subscribe(res => {
        this.preSaveValidation = res;
        if (res.isValid) {
          this.CreateItemOnGrid(newItem);
        }
      }, error => {
        let self = this;
        this.preSaveValidation = error;
        setTimeout(function (this) {
          self.scrollUpToCustomError();
        });

      });
    }
    else {
      this.CreateItemOnGrid(newItem);
    }
  }

  private CreateItemOnGrid(newItem: any) {
    this.tempData.push(newItem);
    this.tempDataToEmit.push(newItem);
    this.dataChange.emit(this.tempDataToEmit);
    this.cloneGridAttachmentsToAllAttachments();
    this.CreateEditItemForm(null);
    if (this.postSaveItemHandler) {
      this.postSaveItemHandler.emit(newItem);
      this.CloseItemFormSubmit();
    }
    this.CloseItemFormSubmit();
  }

  private ClearItemForm() {
    this.itemFormSubmitted = false;
    this.CreateItemForm();
  }

  CloseItemFormSubmit() {
    this.ClearItemForm();
    if (this.showItemForm) {
      this.showItemForm = false;
    }
    this.gridAttachments = [];
    this.isSubmittedUploader = false;
    let fields = this.columns.filter(a => a.typeConfig.customHTML != null && a.typeConfig.customHTML != undefined);
    if (fields.length > 0) {
      for (var i = 0; i < fields.length; i++) {
        fields[i].typeConfig.customHTML.showCustomHtml = false;
      }
    }
    this.preSaveValidation = undefined;
  }

  ShowItemForm(): void {
    if (!this.showItemForm) {
      this.showItemForm = true;
      this.gridAttachments = new Array<DocumentModel>();
      this.loadedValueInDrop = new Array<any>();
      let fields = this.columns.filter(a => a.typeConfig.customHTML != null && a.typeConfig.customHTML != undefined);
      if (fields.length > 0) {
        for (var i = 0; i < fields.length; i++) {
          fields[i].typeConfig.customHTML.showCustomHtml = false;
        }
      }
    }
    //else {
    //  this.showItemForm = false;
    //}
  }

  //=============================================================================================
  // EditItemForm Operations
  OnEditItem(item: any) {
    this.gridAttachments = new Array<DocumentModel>();
    this.loadedValueInDrop = new Array<any>();
    this.indexedUploaderArray = {};
    //this.datePickerOptions = {};
    if (item) {

      this.ShowRowDetails(item);
      let itemIndex = this.tempData.indexOf(item);
      this.EditedIndex = itemIndex;
      for (let col of this.FilterEditableColumns(this.columns)) {
        let fieldValue = item[col.field];
        if (col.typeConfig.type == ColumnFieldType.Date) {
          let dateValue = this.datepipe.transform(fieldValue, col.typeConfig.dateFormat ? col.typeConfig.dateFormat : this.defaultDateFormat);
          this.EditItemForms(itemIndex)[col.field].setValue(dateValue);
        }
        else if (col.typeConfig.type == ColumnFieldType.DateTime) {
          let dateValue = this.datepipe.transform(fieldValue, col.typeConfig.dateTimeFormat ? col.typeConfig.dateTimeFormat : this.defaultDateTimeFormat);
          this.EditItemForms(itemIndex)[col.field].setValue(dateValue);
        }
        else if (col.typeConfig.type == ColumnFieldType.Uploader) {
          this.EditItemForms(itemIndex)[col.field].setValue(this.cloneAttachments(item[col.field], false));
          this.indexedUploaderArray[col.label] = !col.typeConfig.isAttachmentRequired;
        }
        else if (col.typeConfig.type == ColumnFieldType.Mutliselect) {
          this.EditItemForms(itemIndex)[col.field].setValue(this.cloneMutliselectItems(item[col.field]));
        }
        else if (col.typeConfig.type == ColumnFieldType.FilteredURLDropdown) {
          this.LoadSelectValues(item[col.typeConfig.filterByField], col.typeConfig.lookupType, col.field);
          this.EditItemForms(itemIndex)[col.field].setValue(fieldValue);
        }

        else {
          if (col.IsDisabled) {
            this.EditItemForms(itemIndex)[col.field].disable();
          }
          this.EditItemForms(itemIndex)[col.field].setValue(fieldValue);
        }

      }
    }
  }

  itemToBeDeleted: any = null;

  DeleteItem(item: any) {
    if (item) {
      if (this.preDeleteFn) {
        this.preDeleteFn(item).subscribe(response => {
          if (response) {
            //this.DeleteOnGrid(this.item);
            this.itemToBeDeleted = item;
            this.modalService.open(this.deletionPopupId);
          }
        });
      }
      else {
        this.itemToBeDeleted = item;
        this.modalService.open(this.deletionPopupId);
      }
    }
  }

  protected confirmDeletion(): void {
    this.DeleteOnGrid(this.itemToBeDeleted);
    this.modalService.close(this.deletionPopupId);
    if (this.postDeleteItemHandler) {
      this.postDeleteItemHandler.emit(this.itemToBeDeleted);
    }
  }

  protected cancelDeletion(): void {
    this.modalService.close(this.deletionPopupId);
    this.itemToBeDeleted = null;
  }

  private DeleteOnGrid(item: any) {
    item[this.isDeleted] = true;
    this.deleteAttachmentsOfDeletedItem(item);
    this.tempData.splice(this.tempData.indexOf(item), 1);
    this.RemoveEditItemForm(this.tempData.indexOf(item));
    this.tempDataToEmit[this.tempDataToEmit.indexOf(item)] = item;
    this.dataChange.emit(this.tempDataToEmit);
    if (this.allAttachments)
      this.allAttachmentsChange.emit(this.allAttachments)
    // this.dt.reset();
  }

  private deleteAttachmentsOfDeletedItem(deletedItem: any): void {
    let attachmentsCols = this.columns.filter(x => x.typeConfig.type == ColumnFieldType.Uploader)
    for (let i = 0; i < attachmentsCols.length; i++) {
      let attachmentItem = deletedItem[attachmentsCols[i].field];
      if (attachmentItem) {
        let deletedDocs = attachmentItem.filter(x => !x.IsDeleted);
        for (let j = 0; j < deletedDocs.length; j++) {
          let index = this.allAttachments.indexOf(deletedDocs[j]);
          if (index > -1) {
            this.allAttachments[index].IsDeleted = true;
          }
        }
      }
    }
  }

  OnSubmitEditItemForm(oldItem: any) {
    this.EditedIndex = null;
    this.editItemFormsSubmitted = true;
    this.isSubmittedUploader = true;
    let self = this;
    setTimeout(function () {
      let oldItemIndex = self.tempData.indexOf(oldItem);
      if (!self.isValidateUploader)
        self.isValidAttachments = true;
      if (self.editItemForms[oldItemIndex].valid && self.isValidAttachments && oldItemIndex >= 0) {
        self.UpdateItem(oldItem);
      }
      else
        self.scrollUpToFirstError();
    });
  }

  private UpdateItem(oldItem: any): void {
    let itemIndex = this.tempData.indexOf(oldItem);
    let item = {};
    for (let col of this.FilterEditableColumns(this.columns)) {
      if (col.typeConfig.type == ColumnFieldType.Uploader)
        item[col.field] = this.cloneAttachments(this.EditItemForms(itemIndex)[col.field].value, true);
      else
        item[col.field] = this.EditItemForms(itemIndex)[col.field].value;
    }
    item['Status'] = "Edit";
    item['OldItem'] = oldItem;
    item['PrivatId'] = oldItem['PrivatId'];
    // pre save
    if (this.preSaveFn) {
      this.preSaveFn(item).subscribe(res => {
        this.preSaveValidation = res;
        if (res.isValid) {
          this.UpdateItemOnGrid(oldItem, item);
          this.CloseEditItemFormSubmit(oldItem);
        }
      }, error => {
        let self = this;
        this.preSaveValidation = error;
        setTimeout(function (this) {
          self.scrollUpToCustomError();
        });
      });
    }
    else {
      this.UpdateItemOnGrid(oldItem, item);
      this.CloseEditItemFormSubmit(oldItem);
    }

  }

  private UpdateItemOnGrid(oldItem: any, updatedItem: any): void {
    this.UpdateEditableFieldsInItem(this.tempData[this.tempData.indexOf(oldItem)], updatedItem);
    this.UpdateEditableFieldsInItem(this.tempDataToEmit[this.tempDataToEmit.indexOf(oldItem)], updatedItem);
    // post save
    if (this.postSaveItemHandler) {
      this.postSaveItemHandler.emit(updatedItem);
    }
    this.dataChange.emit(this.tempDataToEmit);
    this.cloneGridAttachmentsToAllAttachments(true);
    this.gridAttachments = new Array<DocumentModel>();

    this.loadedValueInDrop = new Array<any>();
  }

  private UpdateEditableFieldsInItem(itemToUpdate: any, updatedItem: any): void {
    for (let col of this.FilterEditableColumns(this.columns)) {
      itemToUpdate[col.field] = updatedItem[col.field];
    }
    itemToUpdate[this.isUpdated] = true;
  }

  private ClearEditItemForm(index: number) {
    this.editItemFormsSubmitted = false;
    this.CreateEditItemForm(index);
  }

  CloseEditItemFormSubmit(item: any) {
    this.EditedIndex = null;
    if (item) {
      this.ClearEditItemForm(this.tempData.indexOf(item));
      if (this.showRowDetails) {
        this.showRowDetails = false;
        this.isSubmittedUploader = false;
        let fields = this.columns.filter(a => a.typeConfig.customHTML != null && a.typeConfig.customHTML != undefined);
        if (fields.length > 0) {
          for (var i = 0; i < fields.length; i++) {
            fields[i].typeConfig.customHTML.showCustomHtml = false;
          }
        }
        this.preSaveValidation = undefined;
      }
    }
  }

  ShowRowDetails(item: any): void {
    let itemIndex = this.tempData.indexOf(item);
    if (!this.showRowDetails) {
      this.selectedRowDetails = itemIndex;
      this.showRowDetails = true;
    }
    else if (this.showRowDetails && this.selectedRowDetails != itemIndex) {
      this.selectedRowDetails = itemIndex;
      this.showRowDetails = true;
    }
    else {
      this.showRowDetails = false;
    }
  }

  //=============================================================================================
  // Form Get Properties to get controls
  get ItemForm() {
    return this.itemForm.controls;
  }

  EditItemForms(index: any) {
    return this.editItemForms[index].controls;
  }

  get ItemEditForm() {
    return this.editItemForms[this.EditedIndex].controls;
  }
  //=============================================================================================
  // Column Header Filteration >>> Not meant for tempData only for column configuration
  FilterVisibleColumns(columns: GridColumn[]): GridColumn[] {
    return this.FilterColumns(columns, x => x.typeConfig &&
      x.visible != false &&
      ((x.header == 'Edit' && this.editable != true) ? false : true));
  }

  FilterEditableColumns(columns: GridColumn[]): GridColumn[] {
    return this.FilterColumns(columns, x => x.typeConfig && x.editable == true && x.typeConfig.type != ColumnFieldType.Button);
  }

  FilterNonEditOrViewColumns(columns: GridColumn[]): GridColumn[] {
    return this.FilterColumns(columns, x => x.header != 'Edit' &&
      x.header != 'View' &&
      x.typeConfig &&
      x.typeConfig.type != ColumnFieldType.Button);
  }

  private FilterColumns(columns: GridColumn[], filter: (col: GridColumn) => boolean): GridColumn[] {
    let filteredColumns = new Array<GridColumn>();
    for (let col of columns) {
      if (filter(col) == true) {
        filteredColumns.push(col);
      }
    }
    return filteredColumns;
  }
  //=============================================================================================
  // Create Add/Edit Forms by code using FormGroup and Reactive forms module.
  private CreateItemForm() {
    var formControls: any[] = [];
    for (let col of this.FilterEditableColumns(this.columns)) {
      let validators = [];
      let validatorFns = [];

      if (col.typeConfig.validations) {
        validators = col.typeConfig.validations.validator || [Validators.nullValidator];
        validatorFns = col.typeConfig.validations.validatorFn || [Validators.nullValidator];
      }
      if (col.typeConfig.type == ColumnFieldType.Text || col.typeConfig.type == ColumnFieldType.TextArea) {
        validators.push(NoWhitespaceValidator())
      }
      formControls[col.field] = new FormControl('', [
        ...validators,
        ...validatorFns
      ]);

      //added on 20240905 to disable and patch the values dynamically
      let formCtrl = (formControls[col.field] as FormControl);
      if (col.typeConfig.type == ColumnFieldType.Text || col.typeConfig.type == ColumnFieldType.TextArea) {
        if (col.IsDisabled) {
          formCtrl.disable();
        }
        if (col.InitValue) {
          formCtrl.patchValue(col.InitValue);
        }
      }
      
    }
    this.itemForm = this.formBuilder.group(formControls);
  }

  private CreateEditItemForms(): void {
    for (let item of this.tempData) {
      let formControls: any[] = [];
      for (let col of this.FilterEditableColumns(this.columns)) {
        let validators = [];
        let validatorFns = [];

        if (col.typeConfig.validations) {
          validators = col.typeConfig.validations.validator || [Validators.nullValidator];
          validatorFns = col.typeConfig.validations.validatorFn || [Validators.nullValidator];
        }
        if (col.typeConfig.type == ColumnFieldType.Text || col.typeConfig.type == ColumnFieldType.TextArea) {
          validators.push(NoWhitespaceValidator())
        }
       
        formControls[col.field] = new FormControl('', [
          ...validators,
          ...validatorFns
        ]);

        //added on 20240905 to disable and patch the values dynamically
        if (col.typeConfig.type == ColumnFieldType.Text || col.typeConfig.type == ColumnFieldType.TextArea) {
          let formCtrl = (formControls[col.field] as FormControl);
          if (col.IsDisabled) {
            formCtrl.disable();
          }
          if (col.InitValue) {
            formCtrl.patchValue(col.InitValue);
          }
        }
        
       
      }
      this.editItemForms.push(this.formBuilder.group(formControls));
    }
  }

  private CreateEditItemForm(index: number): void {
    let formControls: any[] = [];
    for (let col of this.FilterEditableColumns(this.columns)) {
      let validators = [];
      let validatorFns = [];

      if (col.typeConfig.validations) {
        validators = col.typeConfig.validations.validator || [Validators.nullValidator];
        validatorFns = col.typeConfig.validations.validatorFn || [Validators.nullValidator];
      }

      formControls[col.field] = new FormControl('', [
        ...validators,
        ...validatorFns
      ]);
    }
    if (index && this.editItemForms.length - 1 >= index) {
      this.editItemForms[index] = this.formBuilder.group(formControls);
    }
    else {
      this.editItemForms.push(this.formBuilder.group(formControls));
    }
  }

  private RemoveEditItemForm(index: number): void {
    this.editItemForms.splice(index, 1);
  }

  GetDropDownOptions(columnConfig: GridColumn): any[] {
    let itemsFromConfig = columnConfig.typeConfig.lookupType ? this.lookupsEntities[columnConfig.typeConfig.lookupType] : columnConfig.typeConfig.listOptions;
    return [
      {
        [this.lookupKey]: this.undefinedOption,
        [this.lookupLabel]: this.resources.g_lbl_select
      },
      ...itemsFromConfig
    ]
  }

  //=============================================================================================
  // Extra methods for forms

  GetObjectKeys(obj: any): string[] {
    let result = [];
    if (obj) {
      for (let key in obj) {
        result.push(key);
        break;
      }
    }
    return result;
  }
  OnDropFilterChangeHandler(value,colTypeConfig?: any): void {
    if (value && colTypeConfig.FilteredLookupType) { this.LoadSelectValues(value, colTypeConfig.FilteredLookupType, colTypeConfig.FieldFilters) }
  }
  OnDropdownChangeHandler(value: any, dependantField: any, dropdownOptions: any[], colTypeConfig?: any, colfield?:any): void {
    //debugger;
    if (dependantField && dependantField.value != this.undefinedOption)
      //dependantField.setValue(this.undefinedOption);
      dependantField.setValue('');
    if (colTypeConfig != null && colTypeConfig.addingCustomHTML != null) {
      let result = colTypeConfig.addingCustomHTML(value);

    }
    if (value && colTypeConfig.FilteredLookupType) { this.LoadSelectValues(value, colTypeConfig.FilteredLookupType, colTypeConfig.FieldFilters) }
    //added on 20240910
    if (this.DropdownChange) {
      this.DropdownChange.emit(
        { ddlValue: value, ddlName: colfield, CurForm: (this.EditedIndex != null || this.EditedIndex != undefined) ? this.ItemEditForm: this.ItemForm }
      );
    }
  }
  LoadSelectValues(Filtervalue, lookupTypeValue,filteredField): void {
    debugger;
    let url = "/api/eservice/Lookups/LoadLookup" + '/' + lookupTypeValue + '?filter=' + Filtervalue;
    let result = this.http.get<ResultDetails>(url).subscribe(result => {
      if (result.IsSucceeded) {
        if (result.Data) {

          if (this.loadedValueInDrop == undefined) { this.loadedValueInDrop = new Array<any>(); }
          this.loadedValueInDrop[lookupTypeValue] = new Array<any>();
          this.loadedValueInDrop[lookupTypeValue] = result.Data.LookupValues;
          if (this.loadedValueInDrop[lookupTypeValue].length > 0){
            this.itemForm.controls[filteredField].validator = Validators.required;
          }
        }
      };

    });
  }
  ParseToDate(dateString: string): number {
    let result = Date.parse(dateString);
    return result;
  }

  IsSortable(col: GridColumn): string {
    if (col.sortable) {
      return col.field;
    }
    else {
      return '';
    }
  }
  private makeRandom(): string {
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-_";
    let lengthOfCode = 35;
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  //=============================================================================================
  //Datepicker options
  onChangeDatePicker(event: any, filterMaxFromDatePropertyName: string, filterMinToDatePropertyName: string) {
    let field;
    if (filterMaxFromDatePropertyName) {
      field = this.columns.filter(a => a.field == filterMaxFromDatePropertyName);
      let options: any = {};
      let date = new Date(event);
      options.enabledDateRanges = [{ start: new Date(-1), end: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1) }];
      //options.language = field[0].typeConfig.datePickerOptions ? field[0].typeConfig.datePickerOptions.language:null;
      this.datePickerOptions = options;
      this.dateTimePickerOptions = options;
    }
    else if (filterMinToDatePropertyName) {
      field = this.columns.filter(a => a.field == filterMinToDatePropertyName);
      let options: any = {};
      let date = new Date(event);
      options.enabledDateRanges = [{ start: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1), end: new Date(9999, 12, 1) }];
      //options.language = field[0].typeConfig.datePickerOptions ? field[0].typeConfig.datePickerOptions.language : null;
      this.datePickerOptions = options;
      this.dateTimePickerOptions = options;
    }

  }

  private cloneMutliselectItems(items: any[]): any[] {
    let clonedItems: any[] = new Array<any>();
    if (items != null) {
      for (var i = 0; i < items.length; i++) {
        let newItem: any = {};
        for (var prop in items[i])
          if (items[i].hasOwnProperty(prop))
            newItem[prop] = items[i][prop];
        clonedItems.push(newItem);
      }
    }
    return clonedItems;
  }
  private scrollUpToFirstError(): void {
    let target;
    let fieldContainers = document.querySelectorAll('.field-container');

    for (var i = 0; i < fieldContainers.length; i++) {
      if (fieldContainers[i].querySelector('.field-validation-error')) {
        target = fieldContainers[i];
        break;
      }
    }

    if (target)
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY,
        behavior: 'smooth'
      });
  }
  private scrollUpToCustomError(): void {
    let target = document.querySelectorAll('.error-msg')[0];
    if (target)
      window.scrollTo({
        top: target.getBoundingClientRect().top + (window.scrollY - 110),
        behavior: 'smooth'
      });
  }
}
